export const MEALS_SET_CATEGORIES = 'meals/set-categories';
export const MEALS_SET_COURSES = 'meals/set-courses';
